"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DEFAULT_CONFIG = {
    timeoutLoad: 30000,
    timeoutFirstByte: 10000,
    intervalBandwidthEstimate: 10000
};
exports.default = DEFAULT_CONFIG;
//# sourceMappingURL=DEFAULT_CONFIG.js.map